import React from 'react';
import { Alert, Button } from '@mui/material';
import { ErrorOutline, Refresh } from '@mui/icons-material';

interface ErrorScreenProps {
  message?: string;
  error?: Error | string;
  onRetry?: () => void;
}

/**
 * Composant affichant un écran d'erreur avec un message 
 * et optionnellement un bouton pour réessayer l'action.
 */
const ErrorScreen: React.FC<ErrorScreenProps> = ({
  message = 'Une erreur est survenue',
  error,
  onRetry
}) => {
  const errorMessage = typeof error === 'string' 
    ? error 
    : error?.message || 'Erreur inconnue';

  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] p-8">
      <div className="flex items-center justify-center">
        <ErrorOutline color="error" sx={{ fontSize: 60 }} />
      </div>
      
      <h3 className="mt-4 text-xl font-medium text-gray-900">{message}</h3>
      
      <Alert severity="error" className="mt-4 w-full max-w-md">
        {errorMessage}
      </Alert>
      
      {onRetry && (
        <Button 
          variant="outlined" 
          color="primary" 
          className="mt-6"
          startIcon={<Refresh />}
          onClick={onRetry}
        >
          Réessayer
        </Button>
      )}
    </div>
  );
};

export default ErrorScreen;
